// What each restaurant's dish pit looks like around the same layout: the
// specials on the board, the dining room through the pass, the door, and the
// light. A restaurant without its own falls back to the diner's.

export interface RoomLook {
  /** The chalkboard's lines under the restaurant's name. */
  specials: string[];
  /** The dining room's glow through the pass. */
  glow: number;
  booths: number;
  door: number;
  /** Overhead light colour and strength. */
  light: number;
  lightIntensity: number;
  /** Paper lanterns hanging in the dining room. */
  lanterns: boolean;
}

const DINER: RoomLook = {
  specials: ["Short stack ... $6", "Oatmeal & berries ... $5", "The Big Sunny ... $11", "Bottomless coffee ... $2"],
  glow: 0xffe3b0,
  booths: 0xb5442e,
  door: 0x2f6f6a,
  light: 0xfff4e0,
  lightIntensity: 1.6,
  lanterns: false,
};

export const LOOKS: Record<string, RoomLook> = {
  "burger-shack": {
    specials: ["Hamburger ... $6", "Cheeseburger ... $7", "Bacon cheese ... $9", "Double cheese ... $10", "Fries ... $3"],
    // Daylight: the sky through the pickup window.
    glow: 0xbfe3ff,
    booths: 0xd8392b,
    door: 0x2f6f6a,
    light: 0xfff6e6,
    lightIntensity: 1.5,
    lanterns: false,
  },
  "coffee-truck": {
    specials: ["Espresso ... $3", "Double espresso ... $4", "Latte ... $5", "Vanilla, caramel or", "hazelnut latte ... $5.50"],
    // Morning light through the service window.
    glow: 0xfff0d0,
    booths: 0x2f6f6a,
    door: 0x2f6f6a,
    light: 0xfff4e4,
    lightIntensity: 1.45,
    lanterns: false,
  },
  "sunny-side": DINER,
  "lucky-noodle": {
    specials: ["Beef noodle soup ... $12", "Pork dumplings (8) ... $9", "Late-night special ... $15", "Jasmine tea ... $3"],
    glow: 0xff9f6b,
    booths: 0x8c1d18,
    door: 0x7a1f1a,
    light: 0xffd9a8,
    lightIntensity: 1.35,
    lanterns: true,
  },
};

export function lookFor(restaurantId: string): RoomLook {
  return LOOKS[restaurantId] ?? DINER;
}
